import { CommonActionTypes } from "./types";

// 加载
export const fetchLoading = (payload: any) => ({
  type: CommonActionTypes.FETCH_LOADING,
  payload
});


// 更新公共状态
export const fetchUpdateCommonState = (payload: any) => ({
  type: CommonActionTypes.FETCH_UPDATE_COMMON_STATE,
  payload
});

// 获取项目配置
export const fetchGetProjectSetting = (payload: any) => ({
  type: CommonActionTypes.FETCH_GET_PROJECT_SETTING,
  payload
});

